<template>
    <div>
        
        <!-- loading placeholders -->
        <v-row v-if="loading">
          <v-col v-for="i in cols"
                 :key="i">
             <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
             ></v-skeleton-loader>
          </v-col>
        </v-row>

        <!-- loaded items -->
        <v-row v-else>
            <v-col md="8"
                   sm="12"
                   offset-md="2">
                
                <GridTooltip v-for="item in items"
                             :key="item.id"
                             :item="item">
                  
                  <v-row @click="onClick(item)"
                         class="pointer">
                      <v-col :cols="isMobile ? 3 : 2">
                        <v-slide-y-transition>
                            <Cover :src="item.cover"
                                   @click="onClick(item)"
                                   no-hover
                                   no-pointer
                                   :gradient="gradient && !item.canRead"/>x
                        </v-slide-y-transition>
                      </v-col>
                      <v-col align-self="center">
                        <p :class="titleCss(item)">
                            {{ item.title }}
                        </p>
                      </v-col>
                    </v-row>

                </GridTooltip>

            </v-col>
        </v-row>

    </div>
</template>

<style type="text/css">
    .cant-read {
        opacity: 0.5;
    }
</style>

<script>
import utility from '@/mixins/utility'

import Cover from '@/components/UI/Cover'
import GridTooltip from '@/components/Grids/GridTooltip'

export default 
{
   name: 'SimpleList',

   mixins: [ utility ],

   components:
   {
    Cover,
    GridTooltip  
   },

   data: () => ({
     
   }),

   props:
   {
      cols:
      {
         type: Number,
         default: 6
      },

      gradient:
      {
         type: Boolean,
         default: false
      },

      items:
      {
         type: Array,
         required: true,
         default: ()=> []
      },

      loading:
      {
         type: Boolean,
         default: false
      }
   },

   computed:
   {

   },

   methods:
   {
     onClick(item)
     {
        this.$emit('click', item)
     },

     titleCss(item)
     {
        return {
            'cant-read': !item.canRead,
            'text-h4': !this.isMobile,
            'text-h5': this.isMobile
        }
     }
   },

   load(){}
}
</script>